interface AgentDetailPlaceholderTabProps {
  label: string;
}

export const AgentDetailPlaceholderTab = ({ label }: AgentDetailPlaceholderTabProps) => (
  <div className="flex flex-col items-center justify-center gap-2 py-16 text-center">
    <p className="text-sm text-muted-foreground">{label} coming soon</p>
  </div>
);
